export const UnitActiveIcon = () => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M5.41667 8.33333C3.80583 8.33333 2.5 7.0275 2.5 5.41667C2.5 3.80583 3.80583 2.5 5.41667 2.5C7.0275 2.5 8.33333 3.80583 8.33333 5.41667C8.33333 7.0275 7.0275 8.33333 5.41667 8.33333Z"
        fill="#021316"
        stroke="#021316"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M14.5837 8.33333C12.9728 8.33333 11.667 7.0275 11.667 5.41667C11.667 3.80583 12.9728 2.5 14.5837 2.5C16.1945 2.5 17.5003 3.80583 17.5003 5.41667C17.5003 7.0275 16.1945 8.33333 14.5837 8.33333Z"
        fill="#021316"
        stroke="#021316"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M5.41667 17.4993C3.80583 17.4993 2.5 16.1935 2.5 14.5827C2.5 12.9718 3.80583 11.666 5.41667 11.666C7.0275 11.666 8.33333 12.9718 8.33333 14.5827C8.33333 16.1935 7.0275 17.4993 5.41667 17.4993Z"
        fill="#F2DB46"
        stroke="#021316"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M17.5003 14.5827C17.5003 12.9718 16.1945 11.666 14.5837 11.666C12.9728 11.666 11.667 12.9718 11.667 14.5827C11.667 16.1935 12.9728 17.4993 14.5837 17.4993C16.1945 17.4993 17.5003 16.1935 17.5003 14.5827Z"
        fill="#021316"
        stroke="#021316"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};

export const UnitIcon = () => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M5.41667 8.33333V8.33333C3.80583 8.33333 2.5 7.0275 2.5 5.41667V5.41667C2.5 3.80583 3.80583 2.5 5.41667 2.5V2.5C7.0275 2.5 8.33333 3.80583 8.33333 5.41667V5.41667C8.33333 7.0275 7.0275 8.33333 5.41667 8.33333Z"
        stroke="#021316"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M14.5832 8.33333V8.33333C12.9723 8.33333 11.6665 7.0275 11.6665 5.41667V5.41667C11.6665 3.80583 12.9723 2.5 14.5832 2.5V2.5C16.194 2.5 17.4998 3.80583 17.4998 5.41667V5.41667C17.4998 7.0275 16.194 8.33333 14.5832 8.33333Z"
        stroke="#021316"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M5.41667 17.4993V17.4993C3.80583 17.4993 2.5 16.1935 2.5 14.5827V14.5827C2.5 12.9718 3.80583 11.666 5.41667 11.666V11.666C7.0275 11.666 8.33333 12.9718 8.33333 14.5827V14.5827C8.33333 16.1935 7.0275 17.4993 5.41667 17.4993Z"
        stroke="#021316"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M17.4998 14.5827V14.5827C17.4998 12.9718 16.194 11.666 14.5832 11.666V11.666C12.9723 11.666 11.6665 12.9718 11.6665 14.5827V14.5827C11.6665 16.1935 12.9723 17.4993 14.5832 17.4993V17.4993C16.194 17.4993 17.4998 16.1935 17.4998 14.5827Z"
        stroke="#021316"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};
export const PlusIcon = () => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="20" height="20" rx="10" fill="#021316" />
      <path
        d="M10 6V14"
        stroke="#F2DB46"
        stroke-width="2.25"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M14 10H6"
        stroke="#F2DB46"
        stroke-width="2.25"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};
export const DeactivateIcon = () => {
  return (
    <svg
      width="12"
      height="12"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M5.33252 8.66699L7.33335 10.6678"
        stroke="#021316"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M7.33335 8.66699L5.33252 10.6678"
        stroke="#021316"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M6.3327 14.0023C3.93847 14.0023 1.99756 12.0614 1.99756 9.66717C1.99756 7.27294 3.93847 5.33203 6.3327 5.33203C8.72693 5.33203 10.6678 7.27294 10.6678 9.66717C10.6678 12.0614 8.72693 14.0023 6.3327 14.0023"
        stroke="#021316"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M12.586 10.0014C13.9502 8.67977 14.3752 6.66222 13.6602 4.90255C12.9452 3.14288 11.2334 1.99362 9.33398 1.99806"
        stroke="#021316"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M9.33423 1.99805C8.11697 1.9986 6.94872 2.47769 6.08154 3.33194"
        stroke="#021316"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};
export const ActivateIcon = () => {
  return (
    <svg
      width="12"
      height="12"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10 7L7.5 9.5L6 8"
        stroke="#021316"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M14.0002 6.66667C13.4692 4.34438 11.6558 2.53098 9.3335 2"
        stroke="#021316"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M6.66667 13.9997C4.34439 13.4687 2.53099 11.6553 2 9.33301"
        stroke="#021316"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M6.66667 2C4.34438 2.53098 2.53098 4.34438 2 6.66667"
        stroke="#021316"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M14.0002 9.33301C13.4692 11.6553 11.6558 13.4687 9.3335 13.9997"
        stroke="#021316"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};
export const UserIcon = () => {
  return (
    <svg
      width="21"
      height="20"
      viewBox="0 0 21 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12.8478 3.47241C14.1443 4.76895 14.1443 6.87106 12.8478 8.1676C11.5512 9.46414 9.44912 9.46414 8.15258 8.1676C6.85604 6.87106 6.85604 4.76895 8.15258 3.47241C9.44912 2.17586 11.5512 2.17586 12.8478 3.47241"
        stroke="#021316"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M10.5 11.6738C14.295 11.6738 18 13.313 18 15.8338V16.6672C18 17.1272 17.6267 17.5005 17.1667 17.5005H3.83333C3.37333 17.5005 3 17.1272 3 16.6672V15.8338C3 13.3122 6.705 11.6738 10.5 11.6738"
        stroke="#021316"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path d="M12.5 15L14.5 15" stroke="#021316" stroke-linecap="round" />
    </svg>
  );
};
export const UserActiveIcon = () => {
  return (
    <svg
      width="21"
      height="20"
      viewBox="0 0 21 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M12.8473 3.47241C14.1438 4.76895 14.1438 6.87106 12.8473 8.1676C11.5507 9.46414 9.44864 9.46414 8.15209 8.1676C6.85555 6.87106 6.85555 4.76895 8.15209 3.47241C9.44864 2.17586 11.5507 2.17586 12.8473 3.47241Z"
        fill="#021316"
      />
      <path
        d="M12.8473 3.47241C14.1438 4.76895 14.1438 6.87106 12.8473 8.1676C11.5507 9.46414 9.44864 9.46414 8.15209 8.1676C6.85555 6.87106 6.85555 4.76895 8.15209 3.47241C9.44864 2.17586 11.5507 2.17586 12.8473 3.47241"
        stroke="#021316"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M10.5 11.6738C14.295 11.6738 18 13.313 18 15.8338V16.6672C18 17.1272 17.6267 17.5005 17.1667 17.5005H3.83333C3.37333 17.5005 3 17.1272 3 16.6672V15.8338C3 13.3122 6.705 11.6738 10.5 11.6738Z"
        fill="#021316"
      />
      <path
        d="M10.5 11.6738C14.295 11.6738 18 13.313 18 15.8338V16.6672C18 17.1272 17.6267 17.5005 17.1667 17.5005H3.83333C3.37333 17.5005 3 17.1272 3 16.6672V15.8338C3 13.3122 6.705 11.6738 10.5 11.6738"
        stroke="#021316"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path d="M12.5 15L14.5 15" stroke="#D9C334" stroke-linecap="round" />
    </svg>
  );
};
export const UnitGridIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="12"
      height="13"
      viewBox="0 0 12 13"
      fill="none"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M3.25 5.5V5.5C2.2835 5.5 1.5 4.7165 1.5 3.75V3.75C1.5 2.7835 2.2835 2 3.25 2V2C4.2165 2 5 2.7835 5 3.75V3.75C5 4.7165 4.2165 5.5 3.25 5.5Z"
        stroke="#787771"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M8.75 5.5V5.5C7.7835 5.5 7 4.7165 7 3.75V3.75C7 2.7835 7.7835 2 8.75 2V2C9.7165 2 10.5 2.7835 10.5 3.75V3.75C10.5 4.7165 9.7165 5.5 8.75 5.5Z"
        stroke="#787771"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M3.25 11.001V11.001C2.2835 11.001 1.5 10.2175 1.5 9.25098V9.25098C1.5 8.28448 2.2835 7.50098 3.25 7.50098V7.50098C4.2165 7.50098 5 8.28448 5 9.25098V9.25098C5 10.2175 4.2165 11.001 3.25 11.001Z"
        stroke="#787771"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M10.5 9.25098V9.25098C10.5 8.28448 9.7165 7.50098 8.75 7.50098V7.50098C7.7835 7.50098 7 8.28448 7 9.25098V9.25098C7 10.2175 7.7835 11.001 8.75 11.001V11.001C9.7165 11.001 10.5 10.2175 10.5 9.25098Z"
        stroke="#787771"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};
export const HeaderIcon = () => {
  return (
    <svg
      width="142"
      height="32"
      viewBox="0 0 142 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M59.8735 8.3656C59.8735 9.15128 59.1885 9.77579 58.4028 9.77579H54.8449V15.8396H52.085V3.61125C52.085 2.82557 52.7095 2.14062 53.4951 2.14062H61.6664V4.5178H54.8449V7.45905H59.8735V8.3656Z"
        fill="#113541"
      />
      <path
        d="M62.7975 2.14062H64.1876C65.074 2.14062 65.497 2.58383 65.4769 3.45009V4.23576H62.7975V2.14062ZM62.7975 5.1826H64.1876C65.0538 5.1826 65.4769 5.60566 65.4769 6.47192V15.8396H62.7975V5.1826Z"
        fill="#113541"
      />
      <path
        d="M75.993 12.576C75.4088 14.8323 73.9583 16.0813 71.3394 16.0813C68.1161 15.9806 66.5045 14.1071 66.5045 10.4809C66.5045 6.85468 68.1362 5.04158 71.3797 5.02144C74.7641 5.02144 76.3556 7.09643 76.1542 11.2666H69.2644C69.3651 12.8984 70.0702 13.7243 71.3797 13.7243C72.0042 13.7243 72.5884 13.4624 73.1122 12.9588C73.3539 12.6969 73.6561 12.576 74.0187 12.576H75.993ZM71.3394 7.2173C70.1911 7.2173 69.5061 7.94254 69.3047 9.35273H73.3137C73.1525 7.94254 72.4877 7.2173 71.3394 7.2173Z"
        fill="#113541"
      />
      <path
        d="M78.3925 2.14062C79.0976 2.14062 79.6819 2.74499 79.6819 3.45009V15.8396H77.0025V2.14062H78.3925Z"
        fill="#113541"
      />
      <path
        d="M85.7055 7.41876C84.2551 7.41876 83.5097 8.42604 83.4291 10.4809C83.4089 12.6365 84.1342 13.7243 85.6652 13.7243C87.1963 13.7243 87.9618 12.6365 87.9618 10.4809C87.9014 8.42604 87.156 7.41876 85.7055 7.41876ZM89.2914 2.14062C90.0167 2.14062 90.621 2.76514 90.621 3.49038V11.2263C90.621 14.4294 88.949 16.0209 85.6249 16.0008C82.3211 15.9403 80.6691 14.1474 80.6691 10.6018C80.6691 6.97556 82.0793 5.12217 84.9199 5.02144C86.2495 5.02144 87.2769 5.56537 87.9618 6.67337V2.14062H89.2914Z"
        fill="#113541"
      />
      <path
        d="M103.135 8.3656C103.135 9.15128 102.45 9.77579 101.664 9.77579H98.1062V15.8396H95.3462V3.61125C95.3462 2.82557 95.9707 2.14062 96.7564 2.14062H104.928V4.5178H98.1062V7.45905H103.135V8.3656Z"
        fill="#113541"
      />
      <path
        d="M109.436 5.02144C112.659 5.02144 114.291 6.85468 114.291 10.5615C114.291 14.228 112.659 16.0813 109.436 16.0813C106.213 16.0813 104.601 14.228 104.601 10.5615C104.601 6.85468 106.213 5.02144 109.436 5.02144ZM109.436 7.37847C108.026 7.37847 107.321 8.44618 107.321 10.5615C107.341 12.6365 108.046 13.684 109.416 13.684C110.786 13.684 111.471 12.5962 111.491 10.4809C111.491 8.40589 110.806 7.37847 109.436 7.37847Z"
        fill="#113541"
      />
      <path
        d="M115.178 15.8396V10.3399C115.258 6.89497 117.092 5.1826 120.657 5.1826H121.04V7.96269H120.134C118.643 7.96269 117.897 8.74837 117.897 10.2996V15.8396H115.178Z"
        fill="#113541"
      />
      <path
        d="M131.285 12.576C130.801 14.7517 129.23 16.1418 126.752 16.0813C123.529 16.0813 121.877 14.228 121.796 10.5615C121.796 6.91512 123.428 5.08188 126.712 5.02144C129.291 5.02144 130.822 6.16974 131.285 8.48647H128.364C128.042 7.76123 127.477 7.37847 126.631 7.37847C125.221 7.37847 124.516 8.44618 124.516 10.5615C124.516 12.6767 125.261 13.7445 126.752 13.7243C127.377 13.7243 127.921 13.4624 128.364 12.9588C128.626 12.6969 128.928 12.576 129.27 12.576H131.285Z"
        fill="#113541"
      />
      <path
        d="M141.702 12.576C141.118 14.8323 139.668 16.0813 137.049 16.0813C133.825 15.9806 132.214 14.1071 132.214 10.4809C132.214 6.85468 133.846 5.04158 137.089 5.02144C140.474 5.02144 142.065 7.09643 141.864 11.2666H134.974C135.075 12.8984 135.78 13.7243 137.089 13.7243C137.714 13.7243 138.298 13.4624 138.822 12.9588C139.063 12.6969 139.365 12.576 139.728 12.576H141.702ZM137.049 7.2173C135.9 7.2173 135.216 7.94254 135.014 9.35273H139.023C138.862 7.94254 138.197 7.2173 137.049 7.2173Z"
        fill="#113541"
      />
      <path
        d="M52.085 18.584C52.085 17.9444 52.5934 17.3867 53.2331 17.3867H55.4473L57.6943 25.8828L59.8758 17.3867H63.2709V28.5399H61.1223V19.5353L58.8425 28.5399H56.5134L54.2336 19.5353V28.5399H52.085V18.584Z"
        fill="#113541"
      />
      <path
        d="M67.453 26.768C68.6667 26.768 69.4048 26.0464 69.4048 24.8162V24.0125C68.8963 24.2258 68.3059 24.4062 67.6662 24.5374C66.7969 24.7014 66.3541 25.1115 66.3541 25.7511C66.4033 26.44 66.7641 26.768 67.453 26.768ZM67.9614 21.3555C67.1906 21.3555 66.7641 21.5523 66.6493 21.9623H64.4679C64.7303 20.355 65.862 19.5677 67.863 19.5677C70.2577 19.5677 71.4714 20.355 71.5206 21.9623V24.9146C71.5206 27.3093 70.0773 28.3754 67.7318 28.5394C65.6488 28.7034 64.2054 27.7357 64.2054 25.8167C64.2547 23.7337 65.7636 23.1761 67.9614 22.9628C68.8963 22.848 69.372 22.5692 69.372 22.0935C69.3228 21.6015 68.8635 21.3555 67.9614 21.3555Z"
        fill="#113541"
      />
      <path
        d="M79.9683 28.5399H78.8529C78.1313 28.4907 77.7704 28.1462 77.7704 27.4574V22.9961C77.7212 22.094 77.2292 21.6512 76.2615 21.6512C75.2938 21.6512 74.8017 22.094 74.7853 22.9961V28.5399H72.5711V23.439C72.5711 20.9623 73.8176 19.7322 76.2943 19.7322C78.7709 19.7322 79.9847 20.9623 79.9683 23.439V28.5399Z"
        fill="#113541"
      />
      <path
        d="M83.9989 26.768C85.2126 26.768 85.9507 26.0464 85.9507 24.8162V24.0125C85.4422 24.2258 84.8518 24.4062 84.2121 24.5374C83.3428 24.7014 82.8999 25.1115 82.8999 25.7511C82.9492 26.44 83.31 26.768 83.9989 26.768ZM84.5073 21.3555C83.7364 21.3555 83.31 21.5523 83.1952 21.9623H81.0137C81.2762 20.355 82.4079 19.5677 84.4089 19.5677C86.8036 19.5677 88.0173 20.355 88.0665 21.9623V24.9146C88.0665 27.3093 86.6231 28.3754 84.2777 28.5394C82.1947 28.7034 80.7513 27.7357 80.7513 25.8167C80.8005 23.7337 82.3095 23.1761 84.5073 22.9628C85.4422 22.848 85.9179 22.5692 85.9179 22.0935C85.8687 21.6015 85.4094 21.3555 84.5073 21.3555Z"
        fill="#113541"
      />
      <path
        d="M93.0534 26.6204C94.2343 26.6204 94.8576 25.7839 94.9232 24.1109C94.9396 22.356 94.3327 21.4867 93.0862 21.4867C91.8397 21.4867 91.2328 22.356 91.2328 24.1109C91.282 25.7839 91.8725 26.6204 93.0534 26.6204ZM92.4465 28.5394C90.1339 28.5394 88.9858 27.0305 88.9858 24.0453C88.9858 21.1586 90.3307 19.7153 93.0206 19.6661C95.7269 19.6497 97.0882 20.929 97.0882 23.5369V28.6706C97.0882 30.8521 95.7105 31.951 92.9386 32.0002C90.9704 32.0002 89.7238 31.0817 89.2154 29.2447H91.6264C91.774 29.868 92.2825 30.1632 93.1846 30.1632C94.3327 30.1632 94.9232 29.4907 94.9232 28.1458C94.9232 28.1458 94.9232 28.1622 94.9232 27.2601C94.3655 28.113 93.529 28.5394 92.4465 28.5394Z"
        fill="#113541"
      />
      <path
        d="M105.762 25.7183C105.287 27.5553 104.106 28.5722 101.973 28.5722C99.3492 28.4902 98.0371 26.9648 98.0371 24.0125C98.0371 21.0602 99.3656 19.5841 102.006 19.5677C104.762 19.5677 106.058 21.2571 105.893 24.6522H100.284C100.366 25.9807 100.94 26.6532 102.006 26.6532C102.515 26.6532 102.99 26.44 103.417 26.03C103.614 25.8167 103.86 25.7183 104.155 25.7183H105.762ZM101.973 21.3555C101.039 21.3555 100.481 21.9459 100.317 23.094H103.581C103.45 21.9459 102.908 21.3555 101.973 21.3555Z"
        fill="#113541"
      />
      <path
        d="M110.603 21.6184C109.635 21.6184 109.143 22.0612 109.126 22.9633V28.5071H106.912V23.4062C106.912 20.9295 108.159 19.6994 110.635 19.6994C111.751 19.6994 112.604 19.9454 113.227 20.4374C113.85 19.9618 114.703 19.7322 115.818 19.7322C118.295 19.7322 119.525 20.9623 119.509 23.439V28.5399H118.377C117.655 28.4907 117.294 28.1462 117.294 27.4574V22.9961C117.245 22.094 116.753 21.6512 115.786 21.6512C114.818 21.6512 114.326 22.094 114.309 22.9961V28.5071H112.112V22.9633C112.062 22.0612 111.57 21.6184 110.603 21.6184Z"
        fill="#113541"
      />
      <path
        d="M128.427 25.7183C127.951 27.5553 126.77 28.5722 124.638 28.5722C122.014 28.4902 120.702 26.9648 120.702 24.0125C120.702 21.0602 122.03 19.5841 124.671 19.5677C127.426 19.5677 128.722 21.2571 128.558 24.6522H122.949C123.031 25.9807 123.605 26.6532 124.671 26.6532C125.179 26.6532 125.655 26.44 126.081 26.03C126.278 25.8167 126.524 25.7183 126.819 25.7183H128.427ZM124.638 21.3555C123.703 21.3555 123.145 21.9459 122.981 23.094H126.245C126.114 21.9459 125.573 21.3555 124.638 21.3555Z"
        fill="#113541"
      />
      <path
        d="M136.974 28.5399H135.859C135.137 28.4907 134.776 28.1462 134.776 27.4574V22.9961C134.727 22.094 134.235 21.6512 133.267 21.6512C132.299 21.6512 131.807 22.094 131.791 22.9961V28.5399H129.577V23.439C129.577 20.9623 130.823 19.7322 133.3 19.7322C135.777 19.7322 136.99 20.9623 136.974 23.439V28.5399Z"
        fill="#113541"
      />
      <path
        d="M141.447 20.3806C141.447 21.0039 140.972 21.4631 140.365 21.4631H140.135V26.2688C140.135 26.6297 140.348 26.8265 140.775 26.8265H141.447V28.4831C140.742 28.5487 139.971 28.5487 139.151 28.4667C138.331 28.3847 137.937 27.8762 137.954 26.9085V17.4283H139.085C139.66 17.4283 140.135 17.9532 140.135 18.5272V19.905H141.447V20.3806Z"
        fill="#113541"
      />
      <g clip-path="url(#clip0_1880_4371)">
        <path
          d="M28.2507 0.0927734V0.0999084L27.787 0.909723C27.7834 0.916858 27.7798 0.920425 27.7798 0.923993L25.0365 5.7472L19.5889 15.3294C19.5426 15.4079 19.4962 15.4899 19.4498 15.5684L13.2817 26.4171C11.8226 28.9821 9.09703 30.5661 6.14317 30.5661H0L13.3709 7.05646L14.9691 4.2453C15.0119 4.17395 15.0547 4.09547 15.0975 4.02412C15.1011 4.01698 15.1046 4.01342 15.1082 4.00628L15.1153 3.99558C15.1367 3.9599 15.1617 3.92066 15.1867 3.88499C15.3829 3.59246 15.597 3.31419 15.8288 3.05377C17.2772 1.42344 19.2251 0.513734 21.3477 0.203365C21.4904 0.18196 21.6331 0.164123 21.7758 0.149853C22.0184 0.124881 22.261 0.103476 22.5036 0.0927734H28.2507Z"
          fill="url(#paint0_linear_1880_4371)"
        />
        <path
          d="M32.0187 22.5288C32.6323 21.3836 33.8203 20.6594 35.1188 20.638L39.7851 20.5667L37.7195 24.4231C37.1059 25.5682 35.9215 26.2924 34.6229 26.3103L29.9531 26.3816L32.0187 22.5288Z"
          fill="#347287"
        />
        <path
          d="M35.1539 12.1189L33.3095 15.3652L27.0201 26.4244C25.5574 28.993 22.8319 30.5769 19.8816 30.5769H13.7349L21.4513 17.0134C21.4513 17.0134 21.4691 16.9813 21.4763 16.9635L23.2671 13.817C23.3313 13.7028 23.3991 13.5887 23.4705 13.4781C23.6025 13.2711 23.7452 13.0714 23.8914 12.8823C23.9485 12.8109 24.0056 12.7396 24.0627 12.6682C25.6573 10.7561 28.0868 9.67871 30.6125 9.67871H30.6339C31.7327 9.68228 32.8279 9.67871 33.9267 9.67871C35.0683 9.81071 35.7425 11.0843 35.1539 12.1189Z"
          fill="url(#paint1_linear_1880_4371)"
        />
        <path
          d="M43.523 9.63232C42.9022 9.63232 42.1669 12.4934 41.9529 12.9893C41.4178 14.2379 40.6508 15.4509 39.4307 16.1251C37.6577 17.1062 35.4209 16.6424 33.762 15.6506C33.6086 15.5579 33.4588 15.4651 33.3089 15.3652C32.3564 14.7445 31.4681 14.0274 30.4764 13.4781C26.834 11.4731 23.5341 14.0738 21.4507 17.0134C21.4578 16.9956 21.4685 16.9813 21.4757 16.9635L23.2665 13.817C23.3307 13.7028 23.3985 13.5886 23.4699 13.4781C23.6019 13.2711 23.7446 13.0714 23.8908 12.8823C23.9479 12.8109 24.005 12.7396 24.0621 12.6682C25.6567 10.7561 28.0862 9.6787 30.6119 9.6787H30.6333C31.7321 9.68227 32.8273 9.6787 33.9261 9.6787L43.523 9.63232Z"
          fill="#347287"
        />
        <path
          d="M37.1017 0.000293296C36.6522 0.000293296 35.9282 2.61525 35.7712 2.97199C34.7687 5.30511 33.0778 6.96399 30.42 7.16733C28.5399 7.31003 26.6813 6.69999 25.0367 5.74748C24.7442 5.58338 24.4623 5.405 24.1876 5.2195C22.9069 4.35617 21.6583 3.27166 20.1243 3.10756C17.5201 2.82573 14.8944 5.0768 13.3711 7.05674L14.9693 4.24558C15.0121 4.17423 15.0549 4.09574 15.0977 4.02439C15.1013 4.01726 15.1049 4.01369 15.1084 4.00656L15.1156 3.99585C15.137 3.96018 15.162 3.92094 15.1869 3.88526C15.3831 3.59273 15.5972 3.31447 15.8291 3.05404C17.2775 1.42371 19.2253 0.51401 21.3479 0.203641C21.4906 0.182236 21.6333 0.164399 21.776 0.150129C22.0186 0.125157 22.2612 0.103752 22.5038 0.0930495C27.352 -0.120998 32.2464 0.000293296 37.1017 0.000293296Z"
          fill="#347287"
        />
      </g>
      <defs>
        <linearGradient
          id="paint0_linear_1880_4371"
          x1="12.7125"
          y1="6.59637"
          x2="12.6907"
          y2="23.9925"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#194959" />
          <stop offset="1" stop-color="#347287" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_1880_4371"
          x1="23.4709"
          y1="14.1388"
          x2="23.4575"
          y2="26.0688"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#194959" />
          <stop offset="1" stop-color="#347287" />
        </linearGradient>
        <clipPath id="clip0_1880_4371">
          <rect width="43.5231" height="30.6802" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};
export const AssignIcon = () => {
  return (
    <svg
      width="14"
      height="14"
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12.0407 3.96265L7.00335 8.99998L4.48535 6.48131"
        stroke="#10100F"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M13 7C13 10.314 10.314 13 7 13C3.686 13 1 10.314 1 7C1 3.686 3.686 1 7 1C7.96867 1 8.88067 1.23533 9.69067 1.64267"
        stroke="#10100F"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};
export const StatusIcon = () => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M4.5 5.5H2V3"
        stroke="#323232"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M14.0001 8C14.0001 4.686 11.3141 2 8.00011 2C5.58011 2 3.49945 3.436 2.55078 5.5"
        stroke="#323232"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M11.5 10.5H14V13"
        stroke="#323232"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M2 8C2 11.314 4.686 14 8 14C10.42 14 12.5007 12.564 13.4493 10.5"
        stroke="#323232"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};
